// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-quinn-residences -> quinn-residences-websites -> ashcroft-a-quinn-residence
// Generated: 2026-10-29T18:52:32.342Z
// Counts: 0 design, 26 content, 48 slot group, 0 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose the layout that fits your day </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>A simple breakdown of the fees, services, and optional costs associated with living at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Know your costs before you move in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "engrain-sitemap.height": {
    "overrideType": "VALUE",
    "customValue": "1000",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare layouts, check availability, and find the space that fits how home needs to work.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "nextstep.title": {
    "overrideType": "VALUE",
    "customValue": "<p>See townhome living in person</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourquestions.when_a": {
    "overrideType": "VALUE",
    "customValue": "<p>The scheduler shows the times you can book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "tourscheduler.widget.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Inside, every home has a washer and dryer, a dishwasher, and energy-efficient appliances. Outside, the pool, clubhouse, and fenced dog park are just down the street. <a href=\"/amenities\">See all amenities</a>.</p>",
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Pool days, dog park, and in-home ease</p>",
    "mappedField": null
  },
  "amenityhighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Ashcroft, residents spend summer days at the resort-style pool, get together at the clubhouse, and let pups run in the fenced dog park, all within a quiet Northeast Columbia neighborhood of landscaped streets.</p>",
    "mappedField": null
  },
  "feetable.concierge_note": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Includes bi-annual filter change, exterior pest control, 24-hour maintenance response on emergencies, and positive credit reporting.</p>",
    "mappedField": null
  },
  "floorplanshero.offer_label": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Free rent on select homes</p>",
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>New townhomes and single-family homes in Northeast Columbia</p>",
    "mappedField": null
  },
  "interactivemapcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Find your open home, street by street.</p>",
    "mappedField": null
  },
  "lifestylehighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Ashcroft, the shared spaces fit around a busy week: afternoons at the <a href=\"/amenities\">pool and clubhouse</a>, evening laps of the fenced dog park, and weekend time at the playground, all a short walk from your front door.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Clemson Road and Two Notch Road get you to Village at Sandhill errands, the Blue Cross campus, and Fort Jackson quickly, and the pine trails and lake at Sesquicentennial State Park are close by for weekends. <a href=\"/neighborhood\">Explore the neighborhood</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Close to Clemson Road and Sandhill</p>",
    "mappedField": null
  },
  "petpolicy.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Pets at Ashcroft get an on-site fenced dog park and plenty of lawn to explore, and the pine trails at nearby Sesquicentennial State Park are close by for longer walks. Our <a href=\"/pet-policy\">pet policy</a> has the full details.</p>",
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to roam for every pet</p>",
    "mappedField": null
  },
  "touroptions.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Walk through all six plans in 3D, from the Laurens and Dixon to the Underwood, Dahlia, Foxglove and Townsend, then see one in person on a <a href=\"/schedule-a-tour\">self-guided tour</a> or with our leasing team.</p>",
    "mappedField": null
  },
  "virtualtourembed.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Take a 3D walk through six Ashcroft homes, from the 1,250 sq ft Laurens to the Dixon, Underwood, Dahlia, and Foxglove, and on to the four-bedroom Townsend. Pick a tour and look around, then compare details on our <a href=\"/floor-plans\">floor plans</a>.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactdetails.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanshero.link_fees": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/easy-fee-guide"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "floorplanshero.link_pets": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/pet-policy"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "whyquinn.pillar_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Easy access to great schools, shopping, dining, and everyday essentials."
      }
    }
  },
  "whyquinn.pillar_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Spacious layouts that blend functionality, comfort, and modern style."
      }
    }
  },
  "whyquinn.pillar_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Community-Focused Amenities"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Shared spaces designed to bring neighbors together and create lasting memories."
      }
    }
  },
  "whyquinn.pillar_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Dedicated support and personalized service for a hassle-free rental experience."
      }
    }
  },
  "whyquinn.pillar_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Energy-efficient homes built to reduce environmental impact and help lower your utility costs."
      }
    }
  },
  "amenitieslist.amenity_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Lawn Maintenance"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-d3b1-77dd-8257-7dd8fa03a069.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a suburban street with houses, manicured lawns, and blue sky with clouds."
      }
    }
  },
  "amenitieslist.amenity_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Pool"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2b-4ae6-705e-bc09-dabff6c4a1d0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A large swimming pool surrounded by lounge chairs and umbrellas."
      }
    }
  },
  "amenitieslist.amenity_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Dog Park"
      }
    }
  },
  "amenitieslist.amenity_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-cf60-7016-8475-b0b6ab519168.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of a modern white single-story building with a metal roof, surrounded by lush green landscaping."
      }
    }
  },
  "amenitieslist.amenity_photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Refrigerator"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-f11b-737a-acc5-f5076e261466.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with stainless steel refrigerator, gas range, microwave, and granite countertops."
      }
    }
  },
  "amenitieslist.amenity_photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Washer/Dryer"
      }
    }
  },
  "amenitieslist.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-b6dd-736d-93cd-a09890f13b05.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Large swimming pool with lounge chairs and umbrellas surrounding it, with a clubhouse in the background."
      }
    }
  },
  "amenitygroups.community_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2b-4ae6-705e-bc09-dabff6c4a1d0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A large swimming pool surrounded by lounge chairs and umbrellas."
      }
    }
  },
  "amenitygroups.home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-f86e-70ad-b7e0-024f85a9838f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen and living area with island, stainless steel appliances, and large windows."
      }
    }
  },
  "amenityhighlights.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-b6dd-736d-93cd-a09890f13b05.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Large swimming pool with lounge chairs and umbrellas surrounding it, with a clubhouse in the background."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Pool"
      }
    }
  },
  "amenityhighlights.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-cf60-7016-8475-b0b6ab519168.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Ashcroft clubhouse, a white single-story building with a metal roof and green landscaping."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse"
      }
    }
  },
  "amenityhighlights.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129b-05df-73cb-bb66-60fcaec4ff28.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Ashcroft monument sign with stone pillars and landscaping."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Entrance"
      }
    }
  },
  "amenityhighlights.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2b-7504-7019-aae2-b3cfbc3d207b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "an aerial view of a neighborhood with houses and cars parked"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Green Spaces"
      }
    }
  },
  "amenityhighlights.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-b7a6-776a-b44c-87fa7aac958c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story Ashcroft home with stone accents and an attached two-car garage."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Garages"
      }
    }
  },
  "amenityhighlights.card_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-f11b-737a-acc5-f5076e261466.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with stainless steel refrigerator, gas range, microwave, and granite countertops."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Kitchens"
      }
    }
  },
  "floorplanshero.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2b-3a9e-72bd-bfeb-e1328b9aad84.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story single-family home at Ashcroft with a two-car garage and welcoming front entry"
      }
    }
  },
  "floorplanshero.photo_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2b-4c8c-72ff-8ee9-955dac6abb5f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Stone Ashcroft monument sign framed by landscaping at the community entrance"
      }
    }
  },
  "floorplanshero.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-b6dd-736d-93cd-a09890f13b05.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Large swimming pool with lounge chairs and umbrellas surrounding it, with a clubhouse in the background."
      }
    }
  },
  "floorplanshero.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-f86e-70ad-b7e0-024f85a9838f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen and living area with island, stainless steel appliances, and large windows."
      }
    }
  },
  "floorplanshero.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2b-7504-7019-aae2-b3cfbc3d207b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Ashcroft's townhomes and single-family homes with green spaces"
      }
    }
  },
  "floorplanshero.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-b67a-72bf-925a-dcd5a6a67d86.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious living room and kitchen area with high ceilings and a staircase."
      }
    }
  },
  "floorplanshero.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-cf61-7456-aaca-651e3ef0a283.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of the Ashcroft pool and clubhouse"
      }
    }
  },
  "floorplanshero.photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-b7a6-776a-b44c-87fa7aac958c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a modern two-story house with a two-car garage and stone accents."
      }
    }
  },
  "floorplanshero.photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129b-03d7-737b-b704-173b7e854ca6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen and dining area with granite countertops and stainless steel appliances."
      }
    }
  },
  "floorplanshero.photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-f79e-72a0-8248-ba7ad5c39964.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of townhome apartments with blue and gray siding, showing front doors and windows."
      }
    }
  },
  "lifestylehighlights.highlight_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Poolside afternoons"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "The resort-style pool has lounge chairs and umbrellas, so you can swim a few laps or just stretch out in the Carolina sun."
      }
    }
  },
  "lifestylehighlights.highlight_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Meet the neighbors"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "The fenced dog park and the community playground are where pets run off energy, kids play, and neighbors get to know each other."
      }
    }
  },
  "lifestylehighlights.highlight_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Room to focus"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Head to the clubhouse when you want a change of scenery, or turn a spare bedroom in your three- or four-bedroom home into a quiet office."
      }
    }
  },
  "neighborhoodcallout.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2a-3f2f-759c-b17b-b460d0bc3d17.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Forested lake at Sesquicentennial State Park"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Sesquicentennial State Park"
      }
    }
  },
  "petpolicy.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-cf06-72b0-b233-56b62f22c3bf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a suburban neighborhood with townhomes and single-family houses, featuring manicured lawns and trees."
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Lawns and green space"
      }
    }
  },
  "propertyoverview.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-cf11-744b-8cab-64abc344b3d5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a suburban neighborhood with townhouses and single-family homes."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Ashcroft from above"
      }
    }
  },
  "propertyoverview.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-cf61-7456-aaca-651e3ef0a283.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a swimming pool and clubhouse at a multifamily property."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Pool & clubhouse"
      }
    }
  },
  "propertyoverview.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-f86e-70ad-b7e0-024f85a9838f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen and living area with island, stainless steel appliances, and large windows."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Open kitchen & living"
      }
    }
  },
  "propertyoverview.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-b7a6-776a-b44c-87fa7aac958c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a modern two-story house with a two-car garage and stone accents."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Single-family home"
      }
    }
  },
  "propertyoverview.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-b67a-72bf-925a-dcd5a6a67d86.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious living room and kitchen area with high ceilings and a staircase."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Living room"
      }
    }
  },
  "propertyoverview.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167635/01a1129a-cbde-7778-8467-81cfc62a3eef.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Row of modern townhomes with white siding, brown accents, and black roofs."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Townhomes"
      }
    }
  },
  "reviewthemes.chip_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Helpful staff"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "Best customer service I ever experienced"
      }
    }
  },
  "reviewthemes.chip_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Modern homes"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "The townhomes are modern with plenty of space"
      }
    }
  },
  "reviewthemes.chip_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Love living here"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "have loved every minute"
      }
    }
  },
  "tourhero.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167635/019fec2b-3a9e-72bd-bfeb-e1328b9aad84.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Front of a two-story Ashcroft home with a welcoming entry and two-car garage"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
